import {types, actions} from './crud-actions';

//
// List resources
//

export function initStateAddList(initState) {
    return {
        ...initState,
        filter: null,
        list: [],
        current_page: 0,
        total_pages: 0,
        total_count: 0,
        limit_value: 0,
        loading: false,
        loadingInvalid: true,
        loadingError: null,
    }
}

export function loadListInvalidate(state) {
    return {
        ...state,
        loadingInvalid: true
    }
}

export function loadList(state, action) {
    return {
        ...state,
        filter: action.meta.filter,
        loading: true,
        loadingInvalid: false,
        loadingError: null
    };
}

export function loadListSuccess(state, action) {
    return {
        ...state,
        list: action.payload.list,
        total_count: action.payload.total_count,
        total_pages: action.payload.total_pages,
        current_page: action.payload.current_page,
        limit_value: action.payload.limit_value,
        loading: false,
        loadingInvalid: false,
        loadingError: null
    };
}

export function loadListError(state, action) {
    return {
        ...state,
        list: [],
        total_count: 0,
        total_pages: 0,
        current_page: 0,
        limit_value: 0,
        loading: false,
        loadingInvalid: true,
        loadingError: action.payload };
}

//
// Selected resource
//

export function initStateAddSelected(initState) {
    return {
        ...initState,
        selected: null,
        selecting: false,
        selectingError: null
    }
}

export function selectResource(state) {
    return {
        ...state,
        selected: null,
        selecting: true,
        selectingError: null
    };
}

export function selectResourceSuccess(state, action) {
    return {
        ...state,
        selected: action.payload.resource,
        selecting: false,
        selectingError: null
    };
}

export function selectResourceError(state, action) {
    return {
        ...state,
        selected: null,
        selecting: false,
        selectingError: action.payload
    };
}

//
// Create resource
//

export function initStateAddCreate(initState) {
    return {
        ...initState,
        creating: false,
        creatingError: null
    }
}

export function createResource(state) {
    return {
        ...state,

        creating: true,
        creatingError: null
    }
}

export function createResourceSuccess(state) {
    let newState = {
        ...state,
        creating: false,
        creatingError: false,
        loadingInvalid: true
    };

    if (state.list) {
        newState.loadingInvalid = true
    }

    return newState;
}

export function createResourceError(state, action) {
    return {
        ...state,
        creating: true,
        creatingError: action.payload
    }
}

//
// Update resource
//

export function initStateAddUpdate(initState) {
    return {
        ...initState,
        updating: false,
        updatingError: null
    }
}

export function updateResource(state) {
    return {
        ...state,
        updating: true,
        updatingError: null
    }
}

export function updateResourceSuccess(state, action) {
    let newState = {
        ...state,
        updating: false,
        updatingError: false,
        loadingInvalid: true
    };

    if (state.selected && action.payload.resource.id === state.selected.id) {
        newState.selected = action.payload.resource;
    }

    if (state.list) {
        newState.list = state.list.map((item) => { return (item.id === action.payload.resource.id ? action.payload.resource : item) });
    }

    return newState;
}

export function updateResourceError(state, action) {
    return {
        ...state,
        updating: true,
        updatingError: action.payload
    }
}

//
// Destroy resource
//

export function initStateAddDestroy(initState) {
    return {
        ...initState,
        destroying: false,
        destroyingError: null
    }
}

export function destroyResource(state) {
    return {
        ...state,
        destroying: true,
        destroyingError: null
    }
}

export function destroyResourceSuccess(state, action) {
    let newState = {
        ...state,
        destroying: false,
        destroyingError: false,
        loadingInvalid: true
    };

    if (state.selected && action.meta.id === state.selected.id) {
        newState.selected = null;
    }

    if (state.list) {
        newState.list = state.list.filter((item) => item.id !== action.meta.id);
        newState.loadingInvalid = true
    }

    return newState;
}

export function destroyResourceError(state, action) {
    return {
        ...state,
        destroying: true,
        destroyingError: action.payload
    }
}


//
// Reducer
//

export function crudReducer(modelName, initState) {

    let newInitState = initState;
    newInitState = initStateAddList(newInitState);
    newInitState = initStateAddSelected(newInitState);
    newInitState = initStateAddCreate(newInitState);
    newInitState = initStateAddUpdate(newInitState);
    newInitState = initStateAddDestroy(newInitState);

    const LIST_INVALIDATE = actions.resourcesAction(modelName, types.ACTION_INVALIDATE);
    const LIST            = actions.resourcesAction(modelName, types.ACTION_LIST);
    const LIST_SUCCESS    = actions.resourcesActionSuccess(modelName, types.ACTION_LIST);
    const LIST_ERROR      = actions.resourcesActionError(modelName, types.ACTION_LIST);

    const SELECT          = actions.resourceAction(modelName, types.ACTION_SELECT);
    const SELECT_SUCCESS  = actions.resourceActionSuccess(modelName, types.ACTION_SELECT);
    const SELECT_ERROR    = actions.resourceActionError(modelName, types.ACTION_SELECT);

    const CREATE          = actions.resourceAction(modelName, types.ACTION_CREATE);
    const CREATE_SUCCESS  = actions.resourceActionSuccess(modelName, types.ACTION_CREATE);
    const CREATE_ERROR    = actions.resourceActionError(modelName, types.ACTION_CREATE);

    const UPDATE          = actions.resourceAction(modelName, types.ACTION_UPDATE);
    const UPDATE_SUCCESS  = actions.resourceActionSuccess(modelName, types.ACTION_UPDATE);
    const UPDATE_ERROR    = actions.resourceActionError(modelName, types.ACTION_UPDATE);

    const DESTROY          = actions.resourceAction(modelName, types.ACTION_DESTROY);
    const DESTROY_SUCCESS  = actions.resourceActionSuccess(modelName, types.ACTION_DESTROY);
    const DESTROY_ERROR    = actions.resourceActionError(modelName, types.ACTION_DESTROY);

    return (state = newInitState, action) => {

        switch (action.type)
        {
            // Load

            case LIST_INVALIDATE:
                return loadListInvalidate(state);

            case LIST:
                return loadList(state, action);

            case LIST_SUCCESS:
                return loadListSuccess(state, action);

            case LIST_ERROR:
                return loadListError(state, action);

            // Select

            case SELECT:
                return selectResource(state);

            case SELECT_SUCCESS:
                return selectResourceSuccess(state, action);

            case SELECT_ERROR:
                return selectResourceError(state, action);

            // Create

            case CREATE:
                return createResource(state);

            case CREATE_SUCCESS:
                return createResourceSuccess(state);

            case CREATE_ERROR:
                return createResourceError(state, action);

            // Update

            case UPDATE:
                return updateResource(state);

            case UPDATE_SUCCESS:
                return updateResourceSuccess(state, action);

            case UPDATE_ERROR:
                return updateResourceError(state, action);

            // Destroy

            case DESTROY:
                return destroyResource(state);

            case DESTROY_SUCCESS:
                return destroyResourceSuccess(state, action);

            case DESTROY_ERROR:
                return destroyResourceError(state, action);

            // Default

            default:
                return state;
        }

    }
}
